let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7Vq2p")).then(() => parcelRequire('80Id3'));